<button class="btn btn-outline-primary mb-1 mr-2" *ngFor="let ticket of cancelledTickets"
    (click)="callCancelledTicket(ticket.id)">
    <span [title]="jsonToNote(ticket)" class="font-weight-bold">{{ ticket.caption }}{{ ticket.reservationTime | date: 'HH:mm' }}</span><br><span>{{ jsonToNoteShort(ticket) }}</span>
</button>
